import React from "react"
import { useLoginForm } from "../../hooks/auth/useLoginForm"

export default function LoginForm({ onSuccess = () => {} }) {
  const { email, setEmail, password, setPassword, err, loading, submit } =
    useLoginForm(onSuccess)

  return (
    <form
      onSubmit={submit}
      className="bg-white rounded-xl shadow p-6 space-y-4 max-w-md mx-auto"
    >
      <h3 className="text-2xl font-bold">Iniciar sesión</h3>
      {err && <p className="text-red-600">{err}</p>}

      <input
        className="w-full border rounded p-2"
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <input
        className="w-full border rounded p-2"
        type="password"
        placeholder="Contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />

      <button
        disabled={loading}
        className="w-full bg-black text-white rounded p-2"
      >
        {loading ? "Entrando..." : "Entrar"}
      </button>
    </form>
  )
}
